import React from 'react';
import { Text } from 'ComponentLibrary';
import Constants from 'Constants';
import Link from './Link';

const RegisterAccountLink = () => {
    return (
        <Text type="inline" variant="small">
            <Link
                eventLabel={Constants.global.links.accountRegistration.eventLabel}
                to={Constants.global.links.accountRegistration.link}
                blank>
                {Constants.global.links.accountRegistration.label}
            </Link>
        </Text>
    )
};

export default RegisterAccountLink;